<template>
    <div class="row mt-4">
        <div class="col-md-6">
            <order></order>
            <payment></payment>
            <b-card
                header="Your Shopping cart"
                header-tag="header"
                :footer="storeIsOpen ? openMessage : closedMessage"
            >

            <p v-if="cartProducts.length <= 0">Your cart is empty!</p>
            <p v-if="!storeIsOpen"></p>

            <b-list-group-item v-for="(product, index) in cartProducts" :key="index">
                <h5>{{product.name}}</h5>
                <p>{{product.pivot.quantity}} items at ${{product.pivot.price || 0}} each.</p>
                <p>Total:${{product.pivot.price * product.pivot.quantity}}</p>
                <b-button size="sm" variant="secondary" @click="removeProduct(product.id)">Remove Product</b-button>
            </b-list-group-item>
            
            <hr>

            <b-button @click="checkout" v-show="cartProducts.length > 0 && storeIsOpen" variant="primary">Checkout</b-button>

            <b-button @click="emptyCart" v-show="cartProducts.length > 0" variant="primary">Empty Cart</b-button>

            </b-card>

        </div>
    </div>
</template>

<script>
import Order from './Order'
import Payment from './Payment'
export default {
    name: 'Cart',
    data() {
      return {
        closedMessage: "The store is closed. You can't collect!",
        alertMessage: "",
      }
    },
    components: {
        Order,
        Payment
    },
    computed: {
        cartProducts() {
            return this.$store.getters.CART_PRODUCTS
        },
        storeIsOpen() {
            return this.$store.getters.ACCEPTING_ORDERS_STATUS
        },
        openMessage() {
            return "Collect items at: " + this.$store.getters.STORE_ADDRESS
        }
    },
    methods: {
        checkout : function () {
            this.$store.dispatch('CHECKOUT').then(() => {
                this.$bvModal.show('payment')
            })
            .catch((error) => {
                console.log(error)
            })
        },
        emptyCart : function () {
            var vm = this
            vm.alertMessage = ""
            this.$store.dispatch('EMPTY_CART').then(() => {
                 vm.alertMessage = "Cart empytied!"
            })
            .catch(() => {
                vm.alertMessage = "Failed to empty Cart. Please try again!"
            })  
        },
        removeProduct : function (productId) {
            var vm = this
            vm.alertMessage = ""
            this.$store.dispatch('REMOVE_PRODUCTS_FROM_CART', [productId]).then(() => {
                vm.alertMessage = "Product removed!"
            })
            .catch(() => {
                vm.alertMessage = "Failed to remove product. Please try again!"
            })  
        },
    }
}
</script>